var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcEditComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3C97AA",
  d: "M4 16v4h4l8.667-8.667-4-4L4 16ZM18 10l-4-4 2-2 4 4-2 2Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M5.333 16h1.334v1.333H8v1.334H5.333V16ZM14.748 12.08l-5.334 5.334-2.828-2.828 5.333-5.334 2.829 2.829Z",
  clipRule: "evenodd"
})));
export { SvgIcEditComment as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQgMTZWMjBIOEwxNi42NjY3IDExLjMzMzNMMTIuNjY2NyA3LjMzMzMzTDQgMTZaIiBmaWxsPSIjM0M5N0FBIi8+CjxwYXRoIGQ9Ik0xOCAxMEwxNCA2TDE2IDRMMjAgOEwxOCAxMFoiIGZpbGw9IiMzQzk3QUEiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjMzMzMzIDE2SDYuNjY2NjdWMTcuMzMzM0g4VjE4LjY2NjdINS4zMzMzM1YxNloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuNzQ3NSAxMi4wODA5TDkuNDE0MjEgMTcuNDE0Mkw2LjU4NTc5IDE0LjU4NThMMTEuOTE5MSA5LjI1MjQ1TDE0Ljc0NzUgMTIuMDgwOVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";